import { ConfirmPopupVariant } from "../types/popup";

export const getTitleColor = (variant?: ConfirmPopupVariant) => {
  switch (variant) {
    case "delete":
      return "--error-red";
    case "empty":
      return "--moba";
    default:
      return "white";
  }
};

export const getMessageColor = (variant?: ConfirmPopupVariant) => {
  switch (variant) {
    case "delete":
    case "empty":
      return "white";
    default:
      return "--80"; // 예시
  }
};
